/* eslint-disable @typescript-eslint/no-unused-vars */
import { FBHomepageHeroCoopComponent as HeroV3Component } from 'src/components/common/modules/v1/hero/hero-v3/code-split/hero-component';
import { HeroComponent as HeroV2Component } from 'src/components/common/modules/v1/hero/hero-v2/code-split/hero-component';
import { Hero as HeroV1Component } from 'src/components/common/modules/v1/hero/hero-v1/hero'; // code-split not working TODO: make it work
import { FBHomepageVideoDetails as videoGalleryComponent } from 'src/components/football/modules/video-content/code-split/video-component';
import { ImageContrastComponent } from 'src/components/common/modules/v1/imagecontrast/code-split/image-contrast-component';
import { PromoComponent } from 'src/components/common/modules/v1/promo/code-split/promo-component';
import { PromoContentModule } from 'src/components/common/modules/v1/promo';
import { ContentPanelComponent } from 'src/components/common/modules/v1/content-panel/code-split/content-panel-component';
import { BenefitsPaneComponent } from 'src/components/common/modules/v1/benefits-pane/code-split/benefits-pane-component';
import { ContentTileV2Component } from 'src/components/common/modules/v1/content-tile/content-tile-v2/code-split/content-tile-v2-component';
import { CuratedTripsComponent } from 'src/components/common/modules/v1/curated/curated-trips/code-split/curated-component';
import { ContentModule } from 'src/components/common/modules/v1/content';
import { CuratedTripsTabComponent } from 'src/components/common/modules/v1/curated/curated-trips-tabs/code-split/curated-tab-component';
import { AutoRotateImageModule } from 'src/components/common/modules/v1/auto-rotate-module';
import DestinationFilter from 'src/components/common/modules/v1/destination-filter';
import DealFixtures from 'src/components/common/modules/v1/deal-fixtures';
import { ContentTileModule } from 'src/components/common/modules/v1/content-tile';
import { DealsMapComponentModule } from 'src/components/common/modules/v1/deals-map-module';
import { CTAPageNavComponentModule } from 'src/components/common/modules/v1/cta-page-nav';
import { CTAModule } from 'src/components/common/modules/v1/cta-module';
import AnimatedTileCarouselComponent from 'src/components/common/modules/v1/animated-tile-carousel-component';
import { MixedContentComponent } from 'src/components/common/modules/v1/mixed-content/mixed-content/code-split/mixed-content-component';
import { ProfileContentComponent } from 'src/components/common/modules/v1/profile-content/code-split/profile-content-component';
import { ProductIntegrationComponent } from 'src/components/common/modules/v1/product-integration/product-integration/code-split/product-integration-component';
import { TwoColumnArticleComponent } from 'src/components/common/modules/v1/product-integration/two-column-article/code-split/two-column-article-component';
import { LegalTextComponent } from 'src/components/common/modules/v1/legal-text-module/code-split/legal-text-component';
import { GalleryCarouselComponent } from 'src/components/common/modules/v1/gallery-carousel/code-split/gallery-carousel-component';
import { TextModuleomponent } from 'src/components/common/modules/v1/text-module/code-split/text-module-component';
import { TwoColumnTextModuleomponent } from 'src/components/common/modules/v1/two-column-text-module/code-split/two-column-text-module-component';
import { IncentivesCollectionGridComponent } from 'src/components/common/modules/v1/incentives-collection-grid/code-split/incentives-collection-grid-component';
import { InfluencerIntroComponent } from 'src/components/common/modules/v1/influencer-intro/code-split/influencer-intro-component';
import { VideoGalleryComponent } from 'src/components/common/modules/v1/video-gallery/code-split/video-gallery-component';
import { KeyImageComponent } from 'src/components/common/modules/v1/key-image/code-split/key-image-component';
import { FeaturedMediaComponent } from 'src/components/common/modules/v1/featured-media/code-split/featured-media-compoent';
import { SweepstakesModule } from 'src/components/common/modules/v1/sweepstakes';
import { PlaceFilterModule } from 'src/components/common/modules/v1/place-filter';
import { StandardHotelPartnerModule } from 'src/components/common/modules/v1/standard-hotel-partner-module';
import { GameCalendarModule } from 'src/components/common/modules/v1/game-calendar-new';
import { ExploreGalleryModule } from 'src/components/common/modules/v1/explore-gallery';
import { DiscoverMoreModule } from 'src/components/common/modules/v1/discover-more';
import { DoubleImageModule } from 'src/components/common/modules/v1/double-image';
import { SponsorModule } from 'src/components/common/modules/v1/sponsor-module';
import { DynamicEntryFormModule } from 'src/components/common/modules/v1/dynamic-entry-form';
import { HighlightModule } from 'src/components/common/modules/v1/highlight-module';
import { ThreeColumnTextModule } from 'src/components/common/modules/v1/three-column-text-module';
import { ImageCarouselModule } from 'src/components/common/modules/v1/image-carousel';
import { TabbedContentModule } from 'src/components/common/modules/v1/tabbed-content';
import { InspirationModule } from 'src/components/common/modules/v1/inspiration';
import IntroContentBlock from 'src/components/common/modules//v1/intro-content-block';
import GlobalHero from 'src/components/common/modules/v1/global-hero';
import FeaturedHotelPartnersModule from 'src/components/common/modules/v1/featured-hotel-partners-module';
import ItineraryMapModule from 'src/components/common/modules/v1/itinerary-map-module';
import EventModule from 'src/components/common/modules/v1/event-module';
import { QuoteModule } from 'src/components/common/modules/v1/quote';
import ImageModule from 'src/components/common/modules/v1/spotlight-image';
import TwoColumnTile from 'src/components/common/modules/v1/two-column-tile';
import ThreeCardImage from 'src/components/common/modules/v1/three-card-image/components/three-card-image';
import IconModule from 'src/components/common/modules/v1/icon-module';
import LargeTileGalleryModule from 'src/components/common/modules/v1/large-tile-gallery';
import QuizModule from 'src/components/common/modules/v1/quiz-module';
import InteractiveMapModule from 'src/components/common/modules/v1/interactive-map-module';

import { FBHomepageHeroComponent } from 'src/components/football/modules/hero/code-split/hero-component';
import { FBHomepageFeaturedComponent } from 'src/components/football/modules/featured-content/code-split/featured-content-component';
import { MadMarquee } from 'src/components/common/modules/mad-marque/mad-marque';
import {
  HotelModule,
  TabbedDealsModule,
  HotelDealsCarouselModule,
} from 'src/components/common/modules/expedia-deals/hotel';
import { FlightModule } from 'src/components/common/modules/expedia-deals/flight';
import { SearchWizard, StopOverSearchWizard } from 'src/components/common/SearchWizard';
import { CarModule } from 'src/components/common/modules/expedia-deals/car/car-deals';
import { FloatingCTAModule } from 'src/components/common/modules/floating-cta';
import { FallBackModule } from 'src/components/common/modules/fallback-module';
import { PackageDealsComponent } from 'src/components/common/modules/expedia-deals/packages/code-split/package-deals-component';
import ActivityModule from 'src/components/common/modules/expedia-deals/activity-deals/activity-view/activity-module';

type ModulesType = {
  [key: string]: () => any;
};

const v1Modules: ModulesType = {
  heroModule: () => FBHomepageHeroComponent,
  heroModuleCoop: () => HeroV3Component,
  videoGalleryModule: () => videoGalleryComponent,
  contentModule: () => ContentModule,
  featuredContentModule: () => FBHomepageFeaturedComponent,
  quoteModule: () => QuoteModule,
  imageContrastModule: () => ImageContrastComponent,
  PromoComponent: () => PromoComponent,
  promoContentModule: () => PromoContentModule, // This is listicle module
  hotelModule: () => HotelModule,
  tabbedDealsModule: () => TabbedDealsModule,
  hotelDealsCarouselModule: () => HotelDealsCarouselModule,
  sweepstakesModule: () => SweepstakesModule,
  contentPanel: () => ContentPanelComponent,
  mixedContentListing: () => MixedContentComponent,
  videoGalleryTileModule: () => ProfileContentComponent,
  productIntegrationModule: () => ProductIntegrationComponent,
  filterModule: () => PlaceFilterModule,
  twoColumnArticleModule: () => TwoColumnArticleComponent,
  standardHotelPartnerModule: () => StandardHotelPartnerModule,
  bookingWidget: () => SearchWizard,
  flightModule: () => FlightModule,
  flightStopoverModule: () => StopOverSearchWizard,
  carModule: () => CarModule,
  multiColumnContentCarouselModule: () => GameCalendarModule,
  benefitsPanelModule: () => BenefitsPaneComponent,
  exploreGalleryModule: () => ExploreGalleryModule,
  exploreGalleryFilterModule: () => DestinationFilter,
  discoverMoreModule: () => DiscoverMoreModule,
  contentTileModule: () => ContentTileModule,
  doubleImageModule: () => DoubleImageModule,
  sponsorModule: () => SponsorModule,
  legalTextModule: () => LegalTextComponent,
  mobileAppModule: () => MadMarquee,
  galleryCarouselModule: () => GalleryCarouselComponent,
  textModuleArticle: () => TextModuleomponent,
  twoColumnTextModule: () => TwoColumnTextModuleomponent,
  entryFormModule: () => DynamicEntryFormModule,
  collectionsModule: () => IncentivesCollectionGridComponent,
  influencerIntro: () => InfluencerIntroComponent,
  mapModule: () => DealsMapComponentModule,
  featuredGalleryCarouselModule: () => ContentTileV2Component,
  curatedTripsModule: () => CuratedTripsComponent,
  cTAPageNav: () => CTAPageNavComponentModule,
  highlightModule: () => HighlightModule,
  floatingCtaModule: () => FloatingCTAModule,
  threeColumnTextModule: () => ThreeColumnTextModule,
  videoMediaGalleryModule: () => VideoGalleryComponent,
  keyImageModule: () => KeyImageComponent,
  imageCarouselModule: () => ImageCarouselModule,
  featuredMediaModule: () => FeaturedMediaComponent,
  cTAModule: () => CTAModule,
  tabbedContentModule: () => TabbedContentModule,
  inspirationModule: () => InspirationModule,
  tabbedCuratedTripsModule: () => CuratedTripsTabComponent,
  autorotateImageModule: () => AutoRotateImageModule,
  packageDealsModule: () => PackageDealsComponent,
  introContentBlock: () => IntroContentBlock,
  globalHero: () => GlobalHero,
  featuredHotelPartnersModule: () => FeaturedHotelPartnersModule,
  itineraryMapModule: () => ItineraryMapModule,
  eventModule: () => EventModule,
  activityDealsModule: () => ActivityModule,
  interactiveMapModule: () => InteractiveMapModule,
  fixtureDealsModule: () => DealFixtures,
  imageModuleArticle: () => ImageModule,
  twoColumnTileModule: () => TwoColumnTile,
  threeTileBannerModule: () => ThreeCardImage,
  iconModule: () => IconModule,
  largeTileGallery: () => LargeTileGalleryModule,
  animatedTileCarouselModule: () => AnimatedTileCarouselComponent,
  quizModuleNew: () => QuizModule,
  default: () => FallBackModule,
};

export default v1Modules;


export { HeroV1Component, HeroV2Component, HeroV3Component }